import {QLTeam} from "@/graphql/queries/ql/composables";

export const switchTeamUrl = function (team: QLTeam) {
	return import.meta.env.VITE_APP_MAIN_URL + "/studios/" + team.id + "/switch";
};
